import { indexData } from '@/mocks/gossipData';

export default function Index() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
            瓜料索引
          </h2>
          <p className="text-foreground-500 text-base">按分类浏览你感兴趣的吃瓜内容</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
          {indexData.map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-2xl p-4 md:p-5 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-default text-center"
            >
              <div className="w-11 h-11 md:w-12 md:h-12 rounded-xl bg-primary-100 flex items-center justify-center mx-auto mb-3 group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-lg text-primary-500`}></i>
              </div>
              <h3 className="text-sm font-heading text-foreground-800 mb-1 whitespace-nowrap">
                {item.title}
              </h3>
              <span className="text-xs text-foreground-400">{item.count}篇</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}